import * as types from './types';

const updateModals = modals => ({
  type: types.UPDATE_MODALS,
  payload: { ...modals }
});

const resetModals = () => ({
  type: types.RESET_MODALS
});

export { updateModals, resetModals };
